/** @description 可drop的容器 */
import { useDrag } from 'react-dnd'
import { MenuOutlined } from '@ant-design/icons';

type BoxData = {
  [key: string]: any;
}

export interface DropResult {
  data: BoxData;
  [key: string]: any;
}

interface BoxProps {
  data: BoxData;
}

const Box: React.FC<BoxProps> = (props) => {
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: 'box',
    item: props.data,
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult<DropResult>()
      if (item && dropResult) {
        console.log(`You dropped into!`)
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }))

  const previewStyle = {
    position: 'relative',
  } as React.CSSProperties;

  const dragStyle = {
    position: 'absolute',
    left: 4,
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'move',
  } as React.CSSProperties;

  const opacity = isDragging ? 0.4 : 1
  return <div ref={preview} style={previewStyle}>
    <div ref={drag} style={{flexShrink: 0}}>{ props.children }</div>
  </div>
}

export default Box;